module.exports = __webpack_public_path__ + "img/linkDesc.cbe29b72.png";